import { FormControl, Grid, MenuItem, Select, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { Icon } from "../../../utils/MuiIcons/Icon";
import { baseURL } from "../../../api";
import { Global_Data } from "../../../globalData/GlobalData";

const PriceOption = ({
  data,
  priceSelect,
  setPriceSelect,
  hasUserSelectedPriceOption,
  priceOptions,
  setPriceOptions,
  setDisabledPriceOptionRate,
  formAction,
  documentSelectTableData
}) => {
  const { token } = Global_Data();

  const fetchFlagForPriceOption = async (urlPath, onTrue) => {
    if (typeof urlPath === "string" && urlPath.startsWith("/")) {
      const res = await fetch(`${baseURL}${urlPath}`, {
        method: "GET",
        headers: {
          Accept: "*/*",
          Authorization: `Bearer ${token}`,
        },
      });
      const resData = await res.json();
      onTrue(resData);
    }
  };

  const fetchPriceOptions = async () => {
    if (!data) return;

    const allOptions = [
      { key: "Manual", path: data?.pricingOptions?.menu?.bManualPriceEnabled },
      ...Object.keys(data?.pricingOptions || {})
        .filter((k) => /^sPriceOption\d+$/.test(k))
        .map((k) => ({
          key: k,
          path: data?.pricingOptions?.[k]?.bEnabled,
        })),
    ];

    for (const opt of allOptions) {
      await fetchFlagForPriceOption(opt.path, (resData) => {
        if (resData?.data?.records?.[0]?.Enabled === "true") {
          setPriceOptions((prev) => [...prev, opt.key]);
        }
      });
    }

    if(formAction !== "EDIT" && documentSelectTableData?.length == 0){
      await fetchFlagForPriceOption(
        data?.pricingOptions?.menu?.sDefaultPriceOption,
        (resData) => {
          if (resData?.data?.records?.[0]?.PriceOption) {
            const selectedPriceOption = Object.keys(
              data?.pricingOptions || {},
            ).find(
              (key) =>
                data?.pricingOptions?.[key]?.sSubmenuCaption ===
                resData?.data?.records?.[0]?.PriceOption,
            );
            if (!hasUserSelectedPriceOption.current) {
              setPriceSelect(selectedPriceOption || "Manual");
            }
          }
        },
      );
    }


    const disableOptions = Object.keys(data?.pricingOptions || {})
      .filter((k) => /^sPriceOption\d+$/.test(k))
      .map((k) => ({
        key: k,
        path: data?.pricingOptions?.[k]?.bDisableAmountOnSelection,
      }));

    for (const opt of disableOptions) {
      await fetchFlagForPriceOption(opt.path, (resData) => {
        if (resData?.data?.records?.[0]?.EnableAmountEntry !== "true") {
          setDisabledPriceOptionRate((prev) => {
            if (!prev.includes(opt.key)) {
              return [...prev, opt.key];
            }
            return prev;
          });
        }
      });
    }
  };

  useEffect(() => {
    fetchPriceOptions();
  }, []);

  return (
    <>
      {data?.pricingOptions?.menu?.bPriceOptionEnabled && (
        <>
          <Grid item>
            <Typography {...data?.pricingOptions?.menu?.sLabelProps}>
              <Icon
                iconName={data?.pricingOptions?.menu?.sIcon}
                dataSProps={data?.pricingOptions?.menu?.sIconProps}
              />
              {data?.pricingOptions?.menu?.sMenuCaption}
            </Typography>
          </Grid>
          <Grid item {...data?.pricingOptions?.menu?.sSelectProps}>
            <FormControl {...data?.pricingOptions?.menu?.sSelectProps}>
              <Select
                id={`${data?.component?.sName}-pricing`}
                value={priceSelect}
                size="small"
                onChange={(e) => {
                  hasUserSelectedPriceOption.current = true;
                  setPriceSelect(e.target.value);
                }}
                autoWidth
                sx={{ width: 190 }}
                {...data?.pricingOptions?.menu?.sSelectProps}
              >
                {[
                  {
                    key: "Manual",
                    caption: data?.pricingOptions?.menu?.sManualPriceCaption,
                  },
                  ...Object.keys(data?.pricingOptions || {})
                    .filter((k) => /^sPriceOption\d+$/.test(k))
                    .sort(
                      (a, b) =>
                        Number(a.replace("sPriceOption", "")) -
                        Number(b.replace("sPriceOption", "")),
                    )
                    .map((k) => ({
                      key: k,
                      caption: data?.pricingOptions?.[k]?.sSubmenuCaption,
                    })),
                ]
                  .filter((opt) => priceOptions.includes(opt.key))
                  .map((opt) => (
                    <MenuItem key={opt.key} value={opt.key}>
                      {opt.caption}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
        </>
      )}
    </>
  );
};

export default PriceOption;
